/** Textos de respaldo del resolvedor de etiquetas y de las vistas de roles. */
export const PLATFORM_SCOPE_NAME = 'Plataforma';
export const OTHER_PERMISSIONS_CATEGORY = 'Otros permisos';
export const UNNAMED_ROLE = 'Rol sin nombre';
export const UNNAMED_ORGANIZATION = 'Esta organización';
export const ORGANIZATION_GROUP_NAME = 'Organización';
export const OTHER_SCOPE_NAME = 'Otro alcance';
export const ALL_ORGANIZATIONS = 'Todas las organizaciones';
export const UNKNOWN_ORGANIZATION = 'Organización desconocida';
export const UNKNOWN_ROLE = 'Rol desconocido';
export const ORGANIZATION_USER = 'Usuario de organización';
export const SYSTEM_ACTOR_NAME = 'Sistema';
export const SELF_REGISTER_ACTOR_NAME = 'Autorregistro';
export const WHOLE_ORGANIZATION = 'Toda la organización';
